export function layoutBoxSize(el: HTMLElement, axis: "width" | "height"): number {
  const style = getComputedStyle(el);
  const base = parseFloat(axis === "width" ? style.width : style.height);
  if (!Number.isFinite(base)) return 0;
  if (style.boxSizing === "border-box") return base;
  const extras =
    axis === "width"
      ? [style.paddingLeft, style.paddingRight, style.borderLeftWidth, style.borderRightWidth]
      : [style.paddingTop, style.paddingBottom, style.borderTopWidth, style.borderBottomWidth];
  return extras.reduce((sum, v) => sum + (parseFloat(v) || 0), base);
}

export function layoutScale(el: HTMLElement): number {
  const width = el.offsetWidth;
  if (width <= 0) return 1;
  const scale = el.getBoundingClientRect().width / width;
  return scale > 0 && Number.isFinite(scale) ? scale : 1;
}
